<template>
  <div>
  <div :class="[mobile ? 'performance_row owl-carousel' : 'performance_row']">
  <div class="item" v-for="i in circles" :key="i.type" >
  <div  class="performance_col ">
    <div :class=[circleCSS(i)]  :data-percent='performance[i-1]'>
      <svg class="progress" width="178" height="178" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0" ></circle>
        <circle class="bar" r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
      </svg>
    </div>
    <h3 class="logic">{{ titleText[i-1] }}</h3>
  </div>
  </div>
  </div>
  </div>
</template>


<script>

import { mapGetters } from 'vuex';
import { profileFullBar } from '@/common/jQuery';
import $ from 'jquery';

export default {
  name: 'performance-circle',
  props: ['performance', 'circles', 'mobile'],
  data() {
    return {
      titleText: ['', '', '', ''],
      i: 0,
      j: 4,
    };
  },
  created() {
    /* eslint-disable */
    console.log('Load Circles Profile');
    this.titleText[0] = this.getTranslations.home_profile_profile_logic;
    this.titleText[1] = this.getTranslations.home_profile_profile_memory;
    this.titleText[2] = this.getTranslations.home_profile_profile_attention;
    this.titleText[3] = this.getTranslations.home_profile_profile_rounder;
  },
  mounted() {
    profileFullBar();
      /* eslint-disable */
      $(".progressbar__bar").each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%")
    })
    },
    methods: {
      circleCSS(i) {
        if (i===1) {
          return "progressdiv profile_progr logic";
        }
        else if (i===2) {
          return "progressdiv profile_progr memory";
        }
        else if (i===3) {
          return "progressdiv profile_progr attention";
        }
        else if (i===4) {
          return "progressdiv profile_progr mixed";
        }
      },
    },
    computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  };
</script>




// WEBPACK FOOTER //
// src/components/home/profile/PerformanceCircle.vue